export class DocumentFromProcedure {
	FileId: number;
	ExternalUniqueId?: string;
	FileName: string;
	Folder: string;
	FileLinkId: number;
	DuplicatedDocument: boolean;
	FileDate: Date;
	DocumentLocationType: DocumentLocationType;
	UrlSource: string;
	Source: DocumentSourceTypeAsNumber;
	public ProcedureList: Array<ProcedureUseDocument>;
}

export class DocumentUsedForNodeResponse {
	Document: DocumentFromProcedure | undefined | null;
}
export class ProcedureUseDocument {
	ProcedureId: number;
	Name: string;
	public NodeList: Array<NodeUseDocument>;
}

export class NodeUseDocument {
	SchemeId: number;
	Name: string;
	NodeUpdated: Date;
}

export class DocumentForProcedureImport {
	ExternalUniqueId: string | undefined;
	FileId: number;
	CompanyId: number;
	Created: Date;
	DocumentLocationType: DocumentLocationType;
	DocumentLocationSource: DocumentSourceType;
	OriginalFilename: string;
	Folder: string;
	LastModified: Date;
	MimeType: string;
	Name: string;
	Url: string;
}

export type DocumentLocationType = "Local" | "Link" | "SharePoint";
export type DocumentSourceType = "Local" | "Link" | "SharePoint";

export enum DocumentSourceTypeAsNumber {
	Local = 0,
	Link = 1,
	SharePoint = 2,
}
